module.exports = __webpack_public_path__ + "fonts/coconala-icons.ef780f3.woff";